import React from "react";
import CardSimple from "../../../../../components/basic/CardSimple";

const ProductTrouble = () => {
  return (
    <div id="trouble-prepack">
      <br />
      <div>
        <CardSimple>
          <div className="support-wrapper support-manual">
            <h2>Unable to sell a pre-pack product</h2>
            <p>
              The main source of error when selling a Pre-Pack Product is
              missing information. Make sure you have the product's weight
              information as well as a price matrix attached to it. For
              instructions, follow the next steps:
            </p>
            <ul>
              <li>Go to Menu > Inventory > Products</li>
              <li>Search for the product that is causing the problem</li>
              <li>Click on Edit</li>
              <li>
                Check if a price Matrix is Applied to the product. If the
                product doesn’t have a Price Matrix, apply one
              </li>
              <li>
                Check that the field “How much weight in one unit” has a value
                in it
              </li>
              <li>Click on Save</li>
              <li>Try to sell the product again</li>
            </ul>
            <p>
              Note: If after performing these steps you still get this error,
              clear the browsing data and reload the page. (For instructions,
              please check the section Cache Issues under the General category){" "}
            </p>
          </div>
        </CardSimple>
      </div>
      <div id="trouble-priceMatrix-campaign">
        <br />
        <CardSimple>
          <div className="support-wrapper support-manual">
            <h2>
              The product with a Price Matrix doesn't participate in the
              Campaign
            </h2>
            <p>
            The Measurement Settings should be active for a Campaign to be valid
            </p>
            <ul>
              <li>Go to Menu > Pricing > Price Settings</li>
              <li>
                Search for the Price Matrix that is causing the problem. Click on
                Edit
              </li>
              <li>
                Scroll down to see the Price Table and check that the appropriate
                weights are active for the campaign. If they are not, toggle the
                button to activate them
              </li>
            </ul>
          </div>
        </CardSimple>
      </div>
      <div id="trouble-add-campaign">
        <br />
        <CardSimple>
          <div className="support-wrapper support-manual">
            <h2>Unable to add to a Campaign</h2>
            <p>
              The Measurement Settings should be active for a Campaign to be valid
            </p>
            <ul>
              <li>Go to Menu > Pricing > Campaign</li>
              <li>
                Make sure that the Campaign follows the rules:
                <ul>
                  <li>
                    If creating a recurrent sale, no other recurrent sale is
                    affecting the same products during the same days
                  </li>
                  <li>
                    If creating a one-time sale, make sure no other one-time
                    sale are happening for the same products during the same days
                  </li>
                </ul>
              </li>
              <li>
                To check the campaigns, click on Edit. Make the necessary
                changes for the campaign to work
              </li>
            </ul>
          </div>
        </CardSimple>
      </div>
    </div>
  );
};

export default ProductTrouble;
